import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.286 6.286H2.857A2.286 2.286 0 0 0 .571 8.57v4.572h1.715M14.286 13.143h1.143v-8A1.143 1.143 0 0 0 14.285 4H7.429a1.143 1.143 0 0 0-1.143 1.143v6.491M6.857 13.143h2.857",
  stroke: "#6F6C67",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.571 15.428a2.286 2.286 0 1 0 0-4.57 2.286 2.286 0 0 0 0 4.57ZM12 15.428a2.286 2.286 0 1 0 0-4.571 2.286 2.286 0 0 0 0 4.572Z",
  stroke: "#6F6C67",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }